var map = {
	"./google-laurel-da-DK.svg": 73329,
	"./google-laurel-de-DE.svg": 52139,
	"./google-laurel-en-GB.svg": 11265,
	"./google-laurel-en-US.svg": 90201,
	"./google-laurel-es-ES.svg": 45341,
	"./google-laurel-es-MX.svg": 52126,
	"./google-laurel-fr-FR.svg": 23873,
	"./google-laurel-it-IT.svg": 38891,
	"./google-laurel-nb-NO.svg": 25052,
	"./google-laurel-nl-NL.svg": 77513,
	"./google-laurel-pl-PL.svg": 74573,
	"./google-laurel-pt-BR.svg": 98421,
	"./google-laurel-pt-PT.svg": 44941,
	"./google-laurel-sv-SE.svg": 87568
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39909;